import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: 'ng-template[ptCustomTooltipContent]',
})
export class CustomTooltipContentDirective {
  constructor(public template: TemplateRef<unknown>) {}
}
